import { render } from "./ContentR.vue?vue&type=template&id=b0fd3e26&scoped=true"
import script from "./ContentR.vue?vue&type=script&lang=js"
export * from "./ContentR.vue?vue&type=script&lang=js"

import "./ContentR.vue?vue&type=style&index=0&id=b0fd3e26&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0fd3e26"]])

export default __exports__